export const CAMPAIGN_START_ON = '2024-03-04'
export const CAMPAIGN_END_ON = '2024-05-31'
